import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NotificationSnapshot = React.lazy(() =>
    import('../NotificationSnapshot')
);
const notificationSnapshotRoutesRegistry = [
    {
        path: PAGE_URL.NOTIFICATION_SNAPSHOT_PAGE,
        element: <NotificationSnapshot />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default notificationSnapshotRoutesRegistry;
